export function formatLabel(value: string | undefined): string | undefined {
	if (!value || !Number.isNaN(Number(value))) {
		return undefined;
	}
	return value
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
}
